import { PLCustomerData, PLCustomerExtraInformation } from 'types/plCustomerData';

import {
	CustomerActionTypes,
	RESET_CUSTOMER,
	SET_CUSTOMER,
	SET_CUSTOMER_EXTRA_INFORMATION,
	SET_CUSTOMER_IS_MEMBER,
} from './customerActionTypes';

export const setCustomer = (payload: PLCustomerData): CustomerActionTypes => ({
	type: SET_CUSTOMER,
	payload,
});

export const resetCustomer = (): CustomerActionTypes => ({
	type: RESET_CUSTOMER,
});

export const setCustomerIsMember = (payload: boolean): CustomerActionTypes => ({
	type: SET_CUSTOMER_IS_MEMBER,
	payload,
});

export const setCustomerExtraInformation = (
	payload: PLCustomerExtraInformation
): CustomerActionTypes => ({
	type: SET_CUSTOMER_EXTRA_INFORMATION,
	payload,
});
